import { ModalConfig } from 'models/modal-config';
import { Pages } from 'models/pages.enum';

export const SET_SNACKBAR = 'SET_SNACKBAR';
export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const SET_PAGE = 'SET_PAGE';
export const SHOW_MODAL_QUESTION = 'SHOW_MODAL_QUESTION';
interface SetSnackBar {
  type: typeof SET_SNACKBAR;
  payload: { enqueueSnackbar: Function };
}

interface SetPage {
  type: typeof SET_PAGE;
  payload: {
    selectedPage: Pages;
  };
}

interface EnqueueSnackbar {
  type: typeof SHOW_SNACKBAR;
}

interface ShowModalQuestion {
  type: typeof SHOW_MODAL_QUESTION;
  payload: { modalQuestion: ModalConfig };
}

export type GrappiActions =
  | SetSnackBar
  | SetPage
  | EnqueueSnackbar
  | ShowModalQuestion;
